import React from 'react';
// import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import '../styles/SimpleHeader.css';

export const SimpleHeader: React.FC = () => {
  return (
    <header className="simple-header">
      <div className="simple-header-container">
        <div className="logo">
          <Logo size="small" />
        </div>
        {/* <nav className="simple-nav">
          <Link to="/login" className="login-link">Login</Link>
        </nav> */}
      </div>
    </header>
  );
};
